module.exports = __webpack_public_path__ + "static/media/close-for-cart-itmes.22c45ea6.svg";